import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContratoService } from 'src/app/services/contrato/contrato.service';
import { ContratoVolume } from 'src/models/interfaces/contrato/contrato.interface';
import { base64ToBlob } from 'src/utils/blob';
import { showInfo } from 'src/utils/showInfoMessage';

@Component({
    selector: 'spe-termo-fidelidade',
    templateUrl: './termo-fidelidade.component.html',
    styleUrls: ['./termo-fidelidade.component.scss'],
    standalone: false
})
export class TermoFidelidadeComponent {
  @Input() volumeContratado: ContratoVolume[] = [];
  @Input() idPublicacao: number = 0;
  aceite: boolean = false;
  public site = localStorage.getItem('site');

  constructor(private contratoService: ContratoService, private dialog: MatDialog) {}

  submitForm() {
    if (!this.aceite) {
      showInfo(this.dialog, 'Para continuar é necessário ler e aceitar o termo de fidelidade.');
    } else {
      this.contratoService.aceitar(this.idPublicacao).subscribe({
        next: () => {
          window.location.reload();
        }
      });
    }
  }

  openContratoPdf(idContratoCliente: number) {
    this.contratoService.getById(idContratoCliente, 'S', 'S').subscribe({
      next: (response) => {
        const mimeType = 'application/pdf';

        const blob = base64ToBlob(response, mimeType);
        const fileURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.click();
      }
    });
  }

  openTermosDeServico() {
    this.contratoService.getPdfById(11).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error('Erro ao abrir o PDF:', err);
      }
    });
  }

  formatMoney(value: number) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }
}
